import { ApiSyncType, ApiUTMEntityStatus } from "@incendium/api";
import {
  Alert,
  Box,
  Divider,
  Link,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import Loading from "Components/Loading/Loading";
import { useMetaUtmEntites } from "features/dataConnectors/hooks/useMetaUtmEntites";
import { useExternalSyncs } from "Hooks/useExternalSyncs";
import { useMemo } from "react";
import { metaIAIMapping } from "features/utms/components/MetaAdsTrackingTemplate";
import CopyClipboardBtn from "Components/CopyClipboardBtn/CopyClipboardBtn";

function UtmEntityList() {
  const { externalSyncs } = useExternalSyncs();
  const { entites, loading } = useMetaUtmEntites();

  const metaAccount = useMemo(() => {
    return externalSyncs.find((es) => es.type === ApiSyncType.FACEBOOK_ADS);
  }, [externalSyncs]);

  if (loading) {
    return <Loading />;
  }
  return (
    <div>
      <Divider />
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Campaign Name</TableCell>
            <TableCell>Ad Set Name</TableCell>
            <TableCell>Ad Name</TableCell>

            <TableCell>UTM Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {entites.map((entity) => (
            <TableRow key={entity.id}>
              <TableCell>{entity.externalCampaign?.name || ""}</TableCell>
              <TableCell>{entity.externalAdgroup?.name || ""}</TableCell>
              <TableCell>{entity.name}</TableCell>
              <TableCell padding="none">
                <Alert
                  severity={
                    entity.status ===
                      ApiUTMEntityStatus.UTM_ENTITY_STATUS_INCOMPATIBLE
                      ? "error"
                      : "success"
                  }
                  icon={false}
                  sx={{ borderRadius: 0 }}
                >
                  {entity.status ===
                    ApiUTMEntityStatus.UTM_ENTITY_STATUS_COMPATIBLE ? (
                    <Typography variant="body2">
                      UTMs detected & validated
                    </Typography>
                  ) : entity.status ===
                    ApiUTMEntityStatus.UTM_ENTITY_STATUS_MAPPING ? (
                    <Typography variant="body2">
                      UTMs detected & auto-mapped
                    </Typography>
                  ) : (
                    <Tooltip
                      enterDelay={500}
                      title={
                        <>
                          <Typography variant="body2" color={"white"}>
                            Please make sure you add these UTMS to the{" "}
                            <b>URL parameters</b> field in your ad
                          </Typography>
                          <Typography variant="body2" color={"white"} mt={1}>
                            If the field is blank add this:
                          </Typography>
                          <Typography
                            variant="body2"
                            color={"white"}
                            fontWeight={600}
                          >
                            {Object.keys(metaIAIMapping)
                              .map((k) => `${k}=${metaIAIMapping[k]}`)
                              .join("&")}
                            <CopyClipboardBtn
                              color="warning"
                              text={Object.keys(metaIAIMapping)
                                .map((k) => `${k}=${metaIAIMapping[k]}`)
                                .join("&")}
                              stopPropagation
                              isIconButton
                              size="extraSmall"
                            />
                          </Typography>
                          <Typography variant="body2" color={"white"} mt={1}>
                            If the field is not blank, add this at the end of
                            what you already:
                          </Typography>
                          <Typography
                            variant="body2"
                            color={"white"}
                            fontWeight={600}
                          >
                            &
                            {Object.keys(metaIAIMapping)
                              .map((k) => `${k}=${metaIAIMapping[k]}`)
                              .join("&")}
                            <CopyClipboardBtn
                              color="warning"
                              text={`&${Object.keys(metaIAIMapping)
                                .map((k) => `${k}=${metaIAIMapping[k]}`)
                                .join("&")}`}
                              stopPropagation
                              isIconButton
                              size="extraSmall"
                            />
                          </Typography>
                        </>
                      }
                      placement="top"
                      arrow
                    >
                      <Box>
                        <Typography variant="body2">
                          No or Invalid UTMs found. Please add them
                        </Typography>

                        <Link
                          target="_blank"
                          href={`https://adsmanager.facebook.com/adsmanager/manage/ads/?act=${metaAccount?.account}&selected_campaign_ids=${entity.externalCampaign?.externalId}&selected_adset_ids=${entity.externalAdgroup?.externalId}`}
                        >
                          here
                        </Link>
                      </Box>
                    </Tooltip>
                  )}
                </Alert>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}

export default UtmEntityList;
